import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-qtvp0u-0"
})(["min-height:600px;"]);